export default __webpack_public_path__ + "media/pro/greenCheck-filled-ce5b7a57.svg";